import { render, staticRenderFns } from "./UserRankIndex.vue?vue&type=template&id=2f088e84"
import script from "./UserRankIndex.vue?vue&type=script&lang=js"
export * from "./UserRankIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports